﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class KWToggleSubmitter extends TKCustomElementFactory {
    form?: HTMLFormElement;
    fieldElements: NodeListOf<HTMLInputElement>;

    constructor() {
        super();

        this.form = this.querySelector('form') || undefined;
        this.fieldElements = this.querySelectorAll('input');
    }

    connectedCallback(): void {
        if (!this.form || this.fieldElements.length === 0) return;
        this.registerInputListener();
    }

    registerInputListener() {
        const onInput = this.saveLayout.bind(this);

        this.fieldElements.forEach((element) => {
            this.pushListener({
                event: 'input',
                element,
                action: onInput,
            });
        });
    }

    saveLayout() {
        this.form?.submit();
    }
}